import { FileText } from "lucide-react";
import { Container, IconContainer, Mensagem } from "./styles";

export default function LogsVazio() {
    return (
        <Container>
            <IconContainer>
                <FileText size={40} />
            </IconContainer>
            <Mensagem>Não há registros de logs para este histórico.</Mensagem>
        </Container>
    );
}

